import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { Feature, featureEnabled } from 'config/clients';
import { SUSPENSION_SERVICE } from 'config/graphql/constants';
import { GET_SUSPENSION_CODES } from 'config/graphql/suspensionQueries';
import { type SuspensionPoint } from 'typedefs/store/tmxTypes';
import { isStandalone } from 'utils/environment';

export const useFetchSuspensionCodes = () => {
  const { loading, data, previousData } = useQuery(GET_SUSPENSION_CODES, {
    fetchPolicy: isStandalone() || !featureEnabled(Feature.SUSPENSIONS) ? 'cache-only' : 'cache-first',
    context: { serviceName: SUSPENSION_SERVICE },
  });

  const suspensionPoints: SuspensionPoint[] = useMemo(
    () => data?.listSuspensionCodes ?? previousData,
    [data, previousData],
  );

  return useMemo(
    () => ({
      loading,
      suspensionPoints,
    }),
    [loading, suspensionPoints],
  );
};

export default useFetchSuspensionCodes;
